// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* frontend/src/components/MiniHistoryGrid.css */

.mini-history-container {
  width: 100%;
  height: 130px; /* 与父容器高度匹配 */
  background: rgba(0, 0, 0, 0.3);
  border-radius: 0px; /* 取消圆角以完全填满 */
  padding: 0px; /* 完全取消内边距 */
  overflow: hidden;
  border: none; /* 取消边框以节省空间 */
  backdrop-filter: blur(2px);
}

.mini-columns-container {
  display: flex;
  gap: 0px; /* 完全取消列间距 */
  height: 100%;
  align-items: flex-end;
  justify-content: space-around;
}

.mini-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 1;
  height: 100%;
  justify-content: space-between;
}

.mini-grids-column {
  display: flex;
  flex-direction: column-reverse;
  gap: 0px; /* 完全取消格子间垂直间距 */
  flex: 1 1;
  justify-content: flex-start;
  align-items: center;
  height: 100%; /* 确保完全填满高度 */
}

.mini-grid {
  width: 15px; /* 增加宽度以充分利用空间 */
  height: 12px; /* 增加高度以充分利用空间 */
  border-radius: 1px;
  transition: all 0.2s ease;
}

.mini-grid.active {
  background: linear-gradient(135deg, #00ff88 0%, #00cc66 100%);
  box-shadow: 0 0 2px rgba(0, 255, 136, 0.4);
}

.mini-grid.active.red {
  background: linear-gradient(135deg, #ff4444 0%, #cc3333 100%);
  box-shadow: 0 0 2px rgba(255, 68, 68, 0.6);
  animation: miniRedBlink 1.5s infinite ease-in-out;
}

.mini-grid.inactive {
  background: linear-gradient(135deg, #2a2a2a 0%, #1a1a1a 100%);
  border: 1px solid rgba(51, 51, 51, 0.5);
}

.mini-turns {
  font-size: 9px; /* 略微增大字体以适配更大容器 */
  color: #ffd700;
  font-weight: 600;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.8);
  margin-top: 0px; /* 取消上边距 */
  line-height: 0.9; /* 减少行高 */
  height: 12px; /* 固定高度 */
  display: flex;
  align-items: center;
  justify-content: center;
}

.mini-wins {
  font-size: 8px; /* 略微增大字体以适配更大容器 */
  color: #ff4d6d;
  font-weight: bold;
  text-shadow: 0 0 3px rgba(255, 77, 109, 0.6);
  line-height: 0.9; /* 减少行高 */
  height: 10px; /* 固定高度 */
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 0px; /* 取消上边距 */
}

.mini-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #666;
  font-size: 10px;
}

@keyframes miniRedBlink {
  0%, 100% { 
    opacity: 1; 
    box-shadow: 0 0 2px rgba(255, 68, 68, 0.6);
  }
  50% { 
    opacity: 0.6; 
    box-shadow: 0 0 4px rgba(255, 68, 68, 0.8);
  }
}

/* 响应式适配 */
@media (max-width: 768px) {
  .mini-history-container {
    height: 55px;
    padding: 2px; /* 进一步减少移动端内边距 */
  }
  
  .mini-columns-container {
    gap: 0.5px; /* 移动端更小的间距 */
  }
  
  .mini-grids-column {
    gap: 0.5px;
  }
  
  .mini-grid {
    width: 8px;
    height: 5px;
  }
  
  .mini-turns {
    font-size: 7px;
  }
  
  .mini-wins {
    font-size: 6px;
  }
}

@media (max-width: 480px) {
  .mini-history-container {
    height: 50px;
    padding: 2px;
  }
  
  .mini-columns-container {
    gap: 0.5px;
  }
  
  .mini-grids-column {
    gap: 0px; /* 超小屏幕上完全紧贴 */
  }
  
  .mini-grid {
    width: 6px;
    height: 4px;
  }
  
  .mini-turns {
    font-size: 6px;
  }
  
  .mini-wins {
    font-size: 5px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/MiniHistoryGrid.css"],"names":[],"mappings":"AAAA,gDAAgD;;AAEhD;EACE,WAAW;EACX,aAAa,EAAE,aAAa;EAC5B,8BAA8B;EAC9B,kBAAkB,EAAE,cAAc;EAClC,YAAY,EAAE,YAAY;EAC1B,gBAAgB;EAChB,YAAY,EAAE,cAAc;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,QAAQ,EAAE,YAAY;EACtB,YAAY;EACZ,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAO;EACP,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ,EAAE,gBAAgB;EAC1B,SAAO;EACP,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY,EAAE,aAAa;AAC7B;;AAEA;EACE,WAAW,EAAE,gBAAgB;EAC7B,YAAY,EAAE,gBAAgB;EAC9B,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,0CAA0C;AAC5C;;AAEA;EACE,6DAA6D;EAC7D,0CAA0C;EAC1C,iDAAiD;AACnD;;AAEA;EACE,6DAA6D;EAC7D,uCAAuC;AACzC;;AAEA;EACE,cAAc,EAAE,kBAAkB;EAClC,cAAc;EACd,gBAAgB;EAChB,2CAA2C;EAC3C,eAAe,EAAE,UAAU;EAC3B,gBAAgB,EAAE,SAAS;EAC3B,YAAY,EAAE,SAAS;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc,EAAE,kBAAkB;EAClC,cAAc;EACd,iBAAiB;EACjB,4CAA4C;EAC5C,gBAAgB,EAAE,SAAS;EAC3B,YAAY,EAAE,SAAS;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe,EAAE,UAAU;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;IACV,0CAA0C;EAC5C;EACA;IACE,YAAY;IACZ,0CAA0C;EAC5C;AACF;;AAEA,UAAU;AACV;EACE;IACE,YAAY;IACZ,YAAY,EAAE,gBAAgB;EAChC;;EAEA;IACE,UAAU,EAAE,aAAa;EAC3B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,QAAQ,EAAE,cAAc;EAC1B;;EAEA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":["/* frontend/src/components/MiniHistoryGrid.css */\n\n.mini-history-container {\n  width: 100%;\n  height: 130px; /* 与父容器高度匹配 */\n  background: rgba(0, 0, 0, 0.3);\n  border-radius: 0px; /* 取消圆角以完全填满 */\n  padding: 0px; /* 完全取消内边距 */\n  overflow: hidden;\n  border: none; /* 取消边框以节省空间 */\n  backdrop-filter: blur(2px);\n}\n\n.mini-columns-container {\n  display: flex;\n  gap: 0px; /* 完全取消列间距 */\n  height: 100%;\n  align-items: flex-end;\n  justify-content: space-around;\n}\n\n.mini-column {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 1;\n  height: 100%;\n  justify-content: space-between;\n}\n\n.mini-grids-column {\n  display: flex;\n  flex-direction: column-reverse;\n  gap: 0px; /* 完全取消格子间垂直间距 */\n  flex: 1;\n  justify-content: flex-start;\n  align-items: center;\n  height: 100%; /* 确保完全填满高度 */\n}\n\n.mini-grid {\n  width: 15px; /* 增加宽度以充分利用空间 */\n  height: 12px; /* 增加高度以充分利用空间 */\n  border-radius: 1px;\n  transition: all 0.2s ease;\n}\n\n.mini-grid.active {\n  background: linear-gradient(135deg, #00ff88 0%, #00cc66 100%);\n  box-shadow: 0 0 2px rgba(0, 255, 136, 0.4);\n}\n\n.mini-grid.active.red {\n  background: linear-gradient(135deg, #ff4444 0%, #cc3333 100%);\n  box-shadow: 0 0 2px rgba(255, 68, 68, 0.6);\n  animation: miniRedBlink 1.5s infinite ease-in-out;\n}\n\n.mini-grid.inactive {\n  background: linear-gradient(135deg, #2a2a2a 0%, #1a1a1a 100%);\n  border: 1px solid rgba(51, 51, 51, 0.5);\n}\n\n.mini-turns {\n  font-size: 9px; /* 略微增大字体以适配更大容器 */\n  color: #ffd700;\n  font-weight: 600;\n  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.8);\n  margin-top: 0px; /* 取消上边距 */\n  line-height: 0.9; /* 减少行高 */\n  height: 12px; /* 固定高度 */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.mini-wins {\n  font-size: 8px; /* 略微增大字体以适配更大容器 */\n  color: #ff4d6d;\n  font-weight: bold;\n  text-shadow: 0 0 3px rgba(255, 77, 109, 0.6);\n  line-height: 0.9; /* 减少行高 */\n  height: 10px; /* 固定高度 */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 0px; /* 取消上边距 */\n}\n\n.mini-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  color: #666;\n  font-size: 10px;\n}\n\n@keyframes miniRedBlink {\n  0%, 100% { \n    opacity: 1; \n    box-shadow: 0 0 2px rgba(255, 68, 68, 0.6);\n  }\n  50% { \n    opacity: 0.6; \n    box-shadow: 0 0 4px rgba(255, 68, 68, 0.8);\n  }\n}\n\n/* 响应式适配 */\n@media (max-width: 768px) {\n  .mini-history-container {\n    height: 55px;\n    padding: 2px; /* 进一步减少移动端内边距 */\n  }\n  \n  .mini-columns-container {\n    gap: 0.5px; /* 移动端更小的间距 */\n  }\n  \n  .mini-grids-column {\n    gap: 0.5px;\n  }\n  \n  .mini-grid {\n    width: 8px;\n    height: 5px;\n  }\n  \n  .mini-turns {\n    font-size: 7px;\n  }\n  \n  .mini-wins {\n    font-size: 6px;\n  }\n}\n\n@media (max-width: 480px) {\n  .mini-history-container {\n    height: 50px;\n    padding: 2px;\n  }\n  \n  .mini-columns-container {\n    gap: 0.5px;\n  }\n  \n  .mini-grids-column {\n    gap: 0px; /* 超小屏幕上完全紧贴 */\n  }\n  \n  .mini-grid {\n    width: 6px;\n    height: 4px;\n  }\n  \n  .mini-turns {\n    font-size: 6px;\n  }\n  \n  .mini-wins {\n    font-size: 5px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
